import { constants, sendFirebaseEvent, getDaySpentValue } from './connector';
import { format } from 'fecha';
import { isAndroid } from '../../Utils/device';

export const FirebaseEvent = {
  RAIL_LISTING: 'RAIL_LISTING',
  RAIL_REVIEW: 'RAIL_REVIEW',
  RAIL_TRANSACTION: 'RAIL_TRANSACTION',
};

const firebaseMultipleEventSender = async (eventName: string, data: any) => {
  try {
    const daySpentValue = await getDaySpentValue();
    let suffixes: string[] = [''];
    switch (daySpentValue) {
      case 0:
        suffixes = ['_0', '_7', '_30'];
        break;
      case 7:
        suffixes = ['_7', '_30'];
        break;
      case 30:
      case 31:
        suffixes = [`_${daySpentValue}`];
        break;
      default:
        suffixes = [''];
    }
    suffixes.forEach((suffix) => {
      sendFirebaseEvent(eventName + suffix, data);
    });
  } catch (e) {
    // Ignore exception
  }
};

export const firebaseListingTracker = async (request:any) => {
  try {
    if (isAndroid()) {
      const {
        originStation,
        destinationStation,
        departureDate,
      } = request;
      const date = format(departureDate, 'DD-MM-YYYY');
      const params: any = {};
      params[constants.ATTRIBUTE_1] = `${originStation.cityName} | ${destinationStation.cityName}`;
      params[constants.ATTRIBUTE_2] = '';
      params[constants.ATTRIBUTE_3] = date;
      params[constants.ATTRIBUTE_4] = '';
      params[constants.ATTRIBUTE_5] = '';
      params[constants.ATTRIBUTE_6] = '';
      params[constants.ATTRIBUTE_7] = '';
      params[constants.ATTRIBUTE_8] = '';
      params[constants.ATTRIBUTE_9] = '';
      params[constants.ATTRIBUTE_10] = '';
      params[constants.ATTRIBUTE_11] = await getDaySpentValue();
      params[constants.ATTRIBUTE_12] = '';

      const EVENT_NAME = `${FirebaseEvent.RAIL_LISTING}`;
      firebaseMultipleEventSender(EVENT_NAME, params);
    }
  } catch (e) {
    // Ignore exception
  }
};

export const firebaseReviewTracker = async (
  request: any,
  reviewData: any
) => {
  try {
    if (isAndroid()) {
      const {
        originStation,
        destinationStation,
        departureDate
      } = request;
      const date = format(departureDate, 'DD-MM-YYYY');
      const {journeyDetails,passengerList} = reviewData.bookingReviewRequest
      const { totalCollectibleAmount,mmtId,avlDayList } = reviewData.jsonResponse
      const currentAvailabilityStatus = avlDayList[0].availablityStatus
      const { class:ticketClass, quota } = journeyDetails
      const noOfPassengers = passengerList.length
      const params: any = {};
      const isClassAC = ticketClass.includes('A') || ticketClass.includes('C') ? 'Y' : 'N';
      params[constants.ATTRIBUTE_1] = `${originStation.cityName} | ${destinationStation.cityName}`;
      params[constants.ATTRIBUTE_2] = '';
      params[constants.ATTRIBUTE_3] = date;
      params[constants.ATTRIBUTE_4] = isClassAC;
      params[constants.ATTRIBUTE_5] = noOfPassengers;
      params[constants.ATTRIBUTE_6] = quota;
      params[constants.ATTRIBUTE_7] = ticketClass;
      params[constants.ATTRIBUTE_8] = currentAvailabilityStatus;
      params[constants.ATTRIBUTE_9] = totalCollectibleAmount;
      params[constants.ATTRIBUTE_10] = 'INR';
      params[constants.ATTRIBUTE_11] = await getDaySpentValue();
      params[constants.ATTRIBUTE_12] = mmtId;

      const EVENT_NAME = `${FirebaseEvent.RAIL_REVIEW}`;

      firebaseMultipleEventSender(EVENT_NAME, params);
    }
  } catch (e) {
    // Ignore exception
  }
};

export const firebaseThankyouTracker = async (request: any) => {
  try {
    if (isAndroid()) {
      const {
        originStation,
        destinationStation,
        departureDate,
      } = request?.railsLanding || {};
      const { travelInfo, selectedQuota, totalCollectibleAmount, selectedClassType, mmtId } =
        request?.extraData || {};
      const date = departureDate;
      const params: any = {};
      const isClassAC =
        selectedClassType.includes('A') || selectedClassType.includes('C') ? 'Y' : 'N';
      params[constants.ATTRIBUTE_1] = `${originStation.cityName} | ${destinationStation.cityName}`;
      params[constants.ATTRIBUTE_2] = '';
      params[constants.ATTRIBUTE_3] = date;
      params[constants.ATTRIBUTE_4] = isClassAC;
      params[constants.ATTRIBUTE_5] = travelInfo.length;
      params[constants.ATTRIBUTE_6] = selectedQuota?.code;
      params[constants.ATTRIBUTE_7] = selectedClassType;
      params[constants.ATTRIBUTE_8] = travelInfo[0].travellerSeatDetails;
      params[constants.ATTRIBUTE_9] = totalCollectibleAmount;
      params[constants.ATTRIBUTE_10] = 'INR';
      params[constants.ATTRIBUTE_11] = await getDaySpentValue();
      params[constants.ATTRIBUTE_12] = mmtId;

      const EVENT_NAME = `${FirebaseEvent.RAIL_TRANSACTION}`;

      firebaseMultipleEventSender(EVENT_NAME, params);
    }
  } catch (e) {
    //  Ignore exception
  }
};
